import { FC } from "react";
import { BlogCategoriesProps } from "../components/BlogCategories/types";
import { ViewProps } from "../types";
import { useBlogCategoriesQuery } from "@/generated";

export type WithCategoriesProps = {
  categories: BlogCategoriesProps["categories"];
};

export const withCategories =
  (View: FC<WithCategoriesProps>) => (props: ViewProps) => {
    const { data } = useBlogCategoriesQuery({
      variables: {
        pagination: {
          limit: 100,
        },
      },
    });

    const categories = data?.blogCategories?.data?.map((category) => ({
      name: category?.attributes?.title || "",
      key: category?.attributes?.slug || "",
    })) as BlogCategoriesProps["categories"];

    return <View {...props} categories={categories} />;
  };
